import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// constants
import LocalStrings from '../../assets/languages';
import { getUserRolePrivilege } from '../../util/util-common';
import appIcons from '../../constants/appIcons';
import {
  ALLOWED_FEATURE_KEYS,
  SHIMMER_ITEMS
} from '../../constants/section-constants/common-constants';
import {
  ALLOWED_APP_THEMES,
  SITE_ACCESS_TYPES
} from '../../constants/section-constants/type-constants';

// actions
import {
  showSidebar,
  updateActiveTab,
  setProfilePortalToggle,
  commonNetworkModal
} from '../../actions';
import {
  setIsVSPopup,
  setVSPopupContent
} from '../Common/vertical-sliding-popup/actions';
import { openChat } from '../userschat/actions';
import { clearAttendeeProfile } from '../attendee/actions';
import { setHSPopup } from '../Common/horizontal-sliding-popup/actions';

// components
import UserProfilePic from '../Common/userProfilePic';
import EventTools from './EventTools';
import AppShimmer from '../Common/shimmer';

// files
import NoImgIcon from '../../assets/img/placeholders/NoImg.svg';

const SideBar = props => {
  const {
    isLoggedIn,
    session,
    deviceSize,
    userDetails,
    userDetailsAddOn,
    webviewDetails,
    userChatData,
    routes,
    isMobile = false,
    isTab = false,
    componentHeight = false,
    sideNavOutsideClicked = false,
    handleEditProfileToggle,
    profileToggleReducer,
    siteControl,
    rolePermissions,
    restrictAtEditProfile
  } = props;

  const history = useHistory();
  const location = useLocation();
  var webviewUrl = '';

  useEffect(() => {
    const path = location.pathname;
    props.setHSPopup('clear');
    local_updateActiveTab(path);
  }, [location]);

  useEffect(() => {
    if (sideNavOutsideClicked) closeNav();
    return () => {};
  }, [sideNavOutsideClicked]);

  if (webviewDetails?.websiteurl && !_.isEmpty(webviewDetails.websiteurl)) {
    webviewUrl = webviewDetails.websiteurl;
  }

  const closeNav = () => {
    props.showSidebar(false);
  };

  const local_updateActiveTab = path => {
    const split = path.split('/');
    props.updateActiveTab(split[1]);

    // Close the vertical popup section on session change
    props.setIsVSPopup(false);
    props.setVSPopupContent('');

    // Close the Chat details secions and attendee details
    props.openChat({ show: false, user: {} });
    props.clearAttendeeProfile();
  };

  // creates the links that appear in the top menu
  const createTopLinks = () => {
    if (
      _.includes(
        [SITE_ACCESS_TYPES.restrict, SITE_ACCESS_TYPES.noAccess],
        siteControl
      )
    )
      return <></>;

    const routesNew = _.filter(routes, list => {
      return (
        list.hasAccess &&
        list.display &&
        list.position === 'top' &&
        list.section === 'side'
      );
    }); // custom check is login not display in sidebar

    return routesNew.map((routeItem, key) => {
      const selected = _.includes(location.pathname, routeItem.path);
      const menuClass = `${
        selected ? 'top-selected-menu' : 'top-unselected-menu'
      }`;

      return (
        <a
          key={`key_${key}`}
          className={menuClass}
          // to={`${routeItem.path}`}
          href={`#${routeItem.path}`}
          onClick={() => {
            local_updateActiveTab(routeItem.path);
            handleEditProfileToggle();
          }}
        >
          <div className="top-menu-item" onClick={isMobile ? closeNav : null}>
            <div className="top-icon-content">
              <div className="top-icon-container">
                <div className="top-menu-icons">{routeItem.icon}</div>
              </div>
            </div>
            <div className="top-menu-name">{routeItem.name}</div>
          </div>
        </a>
      );
    });
  };

  // creates the links that appear in the left menu
  const createLinks = () => {
    if (profileToggleReducer?.show && !_.isEmpty(profileToggleReducer?.type)) {
      const profileToggleData = _.get(profileToggleReducer, 'data', {});
      const profileToggleType = _.get(profileToggleReducer, 'type');

      const keysLength = _.isEmpty(profileToggleData[profileToggleType])
        ? 0
        : Object.keys(profileToggleData[profileToggleType]).length;

      if (keysLength === 1) return <></>;

      const handleClick = () => {
        if (!_.includes(location.pathname, 'myprofile')) history.goBack();
        if (isMobile) closeNav();
      };

      return _.map(
        profileToggleReducer?.data[profileToggleReducer?.type],
        (item, section_key) => {
          // --- Hides field for conditional form flow. Check userDetails reducer action for 'hideForCondition'
          if (item?.hideForCondition) return;

          let selected = profileToggleReducer?.active_tab?.id === item.id;
          let menuClass = `nav-link menu-link ${
            selected ? 'selected-menu' : 'unselected-menu'
          }`;

          return (
            <>
              <li
                key={`key_${section_key}`}
                className={`nav-item mb-1${deviceSize.isMobile &&
                  deviceSize.width > 991 &&
                  // section_key === 0
                  //   ? ' mt-2'
                  //   :
                  ''}`}
                onClick={handleClick}
              >
                <div
                  className={menuClass}
                  // to={`${routeItem.path}`}
                  onClick={() => {
                    props.setProfilePortalToggle({
                      ...profileToggleReducer,
                      active_tab: item,
                      activeIndex: _.indexOf(
                        profileToggleReducer?.sections,
                        section_key
                      )
                    });
                  }}
                >
                  <div className="menu-name">{item.label}</div>
                </div>
              </li>
            </>
          );
        }
      );
      // } else return <></>;
    } else {
      if (
        _.includes(
          [SITE_ACCESS_TYPES.restrict, SITE_ACCESS_TYPES.noAccess],
          siteControl
        )
      )
        return <></>;

      const routesNew = _.filter(routes, list => {
        return list.hasAccess && list.display && list.position === 'leftside';
      }); // custom check is login not display in sidebar

      return (
        <>
          {_.map(routesNew, (routeItem, key) => {
            if (
              routeItem.key === ALLOWED_FEATURE_KEYS.scans &&
              !rolePermissions?.allow_scan &&
              !rolePermissions?.show_retrieve
            )
              return;

            const selected = _.includes(location.pathname, routeItem.path);
            const menuClass = `nav-link menu-link ${
              selected ? 'selected-menu' : 'unselected-menu'
            }`;

            let iconStyle = selected
              ? {
                  color: 'var(--theme-color)'
                }
              : {};

            const iconType = _.isEqual(ALLOWED_APP_THEMES.dark, session?.theme)
              ? routeItem.darkIconType
              : routeItem.iconType;
            const icon = _.isEqual(ALLOWED_APP_THEMES.dark, session?.theme)
              ? routeItem.darkIcon
              : routeItem.icon;

            const _renderIcon = () => {
              return (
                <>
                  {iconType === 'image' ? (
                    <LazyLoadImage
                      alt={'Image'}
                      effect="blur"
                      placeholder={
                        <img
                          src={NoImgIcon}
                          className="menu-icon-image"
                          alt="lazy load placeholder on error"
                        />
                      }
                      className="menu-icon-image rounded"
                      src={icon}
                      onError={e => {
                        e.target.onerror = null;
                        e.target.src = NoImgIcon;
                      }}
                    />
                  ) : iconType === 'fa-icon' ? (
                    <i
                      className={icon + ' menu-icon-faicon'}
                      style={iconStyle}
                    ></i>
                  ) : (
                    <span>{icon}</span>
                  )}
                </>
              );
            };

            return (
              <li
                key={`key_${key}`}
                className={`nav-item mb-1${
                  isMobile && deviceSize.width > 991 && key === 0 ? ' mt-2' : ''
                }`}
                onClick={isMobile ? closeNav : null}
              >
                {_.includes(routeItem.path, '/chat') &&
                !userDetailsAddOn?.isnetworking ? (
                  <div
                    className={`${menuClass} cursor-pointer`}
                    onClick={() => props.commonNetworkModal(true)}
                  >
                    {/* --- App tab icon (svg | fa icon | image) */}

                    <div className="menu-icons">{_renderIcon()}</div>

                    {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                      ''
                    ) : (
                      <>
                        {' '}
                        <div className="menu-name">{routeItem.name}</div>
                      </>
                    )}
                  </div>
                ) : _.includes(routeItem.path, '/chat') &&
                  userDetailsAddOn?.isnetworking &&
                  userChatData?.totalUnread &&
                  userChatData?.totalUnread > 0 ? (
                  <a
                    className={`${menuClass}${
                      deviceSize.isMobile && deviceSize.width > 991 && key === 0
                        ? ' mt-2'
                        : ''
                    } position-relative`}
                    // to={`${routeItem.path}`}
                    href={`#${routeItem.path}`}
                    onClick={() => {
                      local_updateActiveTab(routeItem.path);
                      handleEditProfileToggle();
                    }}
                  >
                    {/* --- App tab icon (svg | fa icon | image) */}

                    <div className="menu-icons">{_renderIcon()}</div>

                    {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                      ''
                    ) : (
                      <>
                        {' '}
                        <div className="menu-name">{routeItem.name}</div>
                      </>
                    )}
                    <div
                      className="custom-unread-count"
                      style={
                        userChatData?.totalUnread > 99 ? { width: 22 } : {}
                      }
                    >
                      {userChatData?.totalUnread > 99
                        ? '99+'
                        : userChatData?.totalUnread}
                    </div>
                  </a>
                ) : _.isEqual(routeItem.path, '/webview') &&
                  !_.isEmpty(webviewUrl) ? (
                  <a
                    className={`${menuClass}${
                      isMobile && deviceSize.width > 991 && key === 0
                        ? ' mt-2'
                        : ''
                    }`}
                    href={webviewUrl}
                    target={'_blank'}
                  >
                    {/* --- App tab icon (svg | fa icon | image) */}
                    <div className="menu-icons">{_renderIcon()}</div>

                    {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                      ''
                    ) : (
                      <>
                        {' '}
                        <div className="menu-name">{routeItem.name}</div>
                      </>
                    )}
                  </a>
                ) : (
                  <a
                    className={`${menuClass}${
                      isMobile && deviceSize.width > 991 && key === 0
                        ? ' mt-2'
                        : ''
                    }`}
                    href={`#${routeItem.path}`}
                    onClick={() => {
                      local_updateActiveTab(routeItem.path);
                      handleEditProfileToggle();
                    }}
                  >
                    {/* --- App tab icon (svg | fa icon | image) */}

                    <div className="menu-icons">{_renderIcon()}</div>

                    {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                      ''
                    ) : (
                      <>
                        {' '}
                        <div className="menu-name">{routeItem.name}</div>
                      </>
                    )}
                  </a>
                )}
              </li>
            );
          })}

          {/* Shimmer for single route case */}
          {_.isEmpty(userDetails) && isLoggedIn ? (
            <AppShimmer source={SHIMMER_ITEMS.sideBar} />
          ) : (
            ''
          )}
        </>
      );
    }
  };

  const handleNavigation = (type, id) => {
    const isAnalytics = location.pathname === '/analytics';
    const isSameType = location.state?.type === type;
    const newState = { id, type };

    if (isAnalytics && !isSameType) {
      history.replace({ pathname: '/analytics', state: newState });
    } else {
      if (isAnalytics) history.goBack();
      else
        history.push({
          pathname: '/analytics',
          state: newState
        });
    }
  };

  const _renderAnalyticsButtons = () => {
    return (
      <>
        {userDetails?.exhibitoridfk && (
          <li className="mt-1 mb-2 w-100">
            <button
              type="button"
              className="custom-button-primary-md w-100"
              onClick={() =>
                handleNavigation('exhibitor', userDetails.exhibitoridfk)
              }
            >
              {location.pathname === '/analytics' &&
              location.state?.type === 'exhibitor'
                ? `${_.startCase(_.toLower(LocalStrings.dynamic.kEXIT))} `
                : ''}
              {LocalStrings.dynamic.kExhibitorText}{' '}
              {LocalStrings.dynamic.kStatsText}
            </button>
          </li>
        )}

        {userDetails?.sponsoridfk && (
          <li className="mt-1 mb-2 w-100">
            <button
              type="button"
              className="custom-button-primary-md w-100"
              onClick={() =>
                handleNavigation('sponsor', userDetails.sponsoridfk)
              }
            >
              {location.pathname === '/analytics' &&
              location.state?.type === 'sponsor'
                ? `${_.startCase(_.toLower(LocalStrings.dynamic.kEXIT))} `
                : ''}
              {LocalStrings.dynamic.kSponsorText}{' '}
              {LocalStrings.dynamic.kStatsText}
            </button>
          </li>
        )}
      </>
    );
  };

  return (
    <>
      <div
        className={`${
          deviceSize.isMobile || deviceSize.isTab ? 'bg-white' : ''
        }`}
        style={
          deviceSize.isMobile || deviceSize.isTab
            ? {}
            : { border: 'unset !important' }
        }
      >
        {/* ------- User profile - Sidebar close - User details and edit profile - Selected top links -  Logout ------- */}
        <div
          className={`${
            !profileToggleReducer?.show
              ? 'blank-sidebar-top'
              : 'blank-sidebar-top-WO-header'
          }`}
        >
          {isMobile || isTab ? (
            <>
              {/* ----- User profile - Side bar close ----- */}
              <div className="closebtn-container">
                {/* --- User profile --- */}
                <div className="avatar">
                  <UserProfilePic info={userDetails} />
                </div>

                {/* --- Sidebar close button --- */}
                <span
                  className="font-icomoon custom-text4-medium-primary"
                  onClick={closeNav}
                >
                  {appIcons.crossIcon}
                </span>
              </div>

              {/* ----- Username - Edit profile button ----- */}
              <div className="sidebar-username">
                {/* --- User name --- */}
                <div className="ml-1">
                  <span className="custom-text1-medium">
                    {userDetails?.username}
                  </span>
                </div>

                {/* --- Edit profile button --- */}
                <div className="mt-1 mb-2" onClick={isMobile ? closeNav : null}>
                  <span
                    className="custom-button-primary-sm-tags"
                    onClick={() =>
                      !profileToggleReducer?.show
                        ? handleEditProfileToggle('profile')
                        : null
                    }
                    style={
                      profileToggleReducer?.show
                        ? { opacity: '0.6', cursor: 'not-allowed' }
                        : {}
                    }
                  >
                    {LocalStrings.dynamic.kEditProfile.toUpperCase()}
                  </span>
                </div>
              </div>

              {/* ----- Selected top menu section - Logout ----- */}
              <div className="top-menu-section">
                {createTopLinks()}

                <a
                  className="top-unselected-menu"
                  onClick={props.handleAppLogout}
                >
                  <div
                    className="top-menu-item"
                    onClick={isMobile ? closeNav : null}
                  >
                    <div className="top-icon-content">
                      <div className="top-icon-container">
                        <div className="top-menu-icons">
                          {appIcons.logoutIcon}
                        </div>
                      </div>
                    </div>
                    <div className="top-menu-name">
                      {LocalStrings.dynamic.kLogoutText}
                    </div>
                  </div>
                </a>
              </div>
            </>
          ) : (
            ''
          )}
        </div>

        {/* ------- Sidebar items | Normal items - Profile sections ------- */}
        <nav
          className="navbar scrollbar-hide-no-maxheight"
          style={{
            alignItems: 'start',
            height: componentHeight
              ? // ? deviceSize.height - 320 + 25
                deviceSize.height - 320 + 48
              : isMobile
              ? deviceSize.height - 192
              : '100%'
          }}
        >
          <ul
            className="navbar-nav w-100"
            style={
              !deviceSize.isMobile &&
              !deviceSize.isTab &&
              deviceSize.width > 991
                ? { padding: 0 }
                : deviceSize.isMobile || deviceSize.isTab
                ? { padding: '1rem' }
                : {}
            }
          >
            {/* --- Back to overview button for EditProfile --- */}
            {!deviceSize.isMobile &&
            profileToggleReducer?.show &&
            siteControl !== SITE_ACCESS_TYPES.restrict &&
            !restrictAtEditProfile ? (
              <li className="mt-1 mb-2 w-100">
                <button
                  type="button"
                  className="custom-button-outerline-primary-md-hover w-100"
                  onClick={() => handleEditProfileToggle(null)}
                >
                  {LocalStrings.dynamic.KToText}{' '}
                  {LocalStrings.dynamic.kOverviewText}
                </button>
              </li>
            ) : (
              ''
            )}

            {/* --- Lead-retrieval button for Edit-Exhibitor mode --- */}
            {/* {!profileToggleReducer?.show && rolePermissions?.show_retrieve ? (
              <li className="mt-1 mb-2 w-100">
                <button
                  type="button"
                  className="custom-button-primary-md w-100"
                  onClick={() =>
                    history.push(
                      location.pathname === '/myscans'
                        ? '/overview'
                        : '/myscans'
                    )
                  }
                >
                  {location.pathname === '/myscans'
                    ? `${_.startCase(_.toLower(LocalStrings.dynamic.kEXIT))} `
                    : ''}
                  {LocalStrings?.dynamic.KLeadRetrival}
                </button>
              </li>
            ) : (
              ''
            )} */}

            {/* -------------- Sidebar Event Tools section -------------- */}
            {!_.includes(
              [
                '#/myprofile',
                '#/myprofile-speaker',
                '#/myprofile-exhibitor',
                '#/myprofile-sponsor'
              ],
              window.location.hash
            ) && <EventTools />}

            {/* --- All features / Edit profile sections --- */}

            {createLinks()}

            {/* --- Analytics buttons for edit profile section --- */}
            {profileToggleReducer?.show &&
            siteControl !== SITE_ACCESS_TYPES.restrict &&
            !restrictAtEditProfile
              ? _renderAnalyticsButtons()
              : ''}
          </ul>
        </nav>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  const rolePermissions = getUserRolePrivilege(
    {
      ...state.userDetails,
      ...state.userDetailsAddOn
    },
    state.eventTabs,
    state.userAccessByRole,
    ALLOWED_FEATURE_KEYS.scans
  );

  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    show: state.showSidebar,
    userDetails: {
      ...state.userDetails,
      ...state.userDetailsAddOn
    },
    userDetailsAddOn: state.userDetailsAddOn,
    webviewDetails: state.webviewDetails,
    deviceSize: state.deviceSize,
    userChatData: state.unreadChatCountReducer,
    profileToggleReducer: state.profileToggleReducer,
    siteControl: state.siteControlReducer,
    restrictAtEditProfile: state.restrictAtEditProfile,
    rolePermissions
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showSidebar,
      updateActiveTab,
      setIsVSPopup,
      setVSPopupContent,
      openChat,
      clearAttendeeProfile,
      setHSPopup,
      setProfilePortalToggle,
      commonNetworkModal
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
